<template>
  <div class="develop-container">
    <div class="service-List">
      <el-row :gutter="24">
        <el-col :span="6" v-for="(item, index) in serviceList" :key="index">
          <el-card shadow="hover">
            <router-link
              style="display:flex; flex-direction: row;
  align-items: center;color:#333333;padding:30px 0"
              :to="item.path"
            >
              <img :src="item.icon" alt="" />
              {{ item.title }}
            </router-link>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="data-directory">
      <div class="title">数据开放资源项目</div>
      <div class="data-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="数据" name="first">
            <div class="data-list">
              <router-link
                v-for="(item, index) in list"
                :key="index"
                class="data-item"
                :to="'/data_public/detail/' + item.id"
              >
                <div class="item-box">
                  <div class="data-info">
                    <div class="title">{{ item.name }}</div>
                    <div class="desc">{{ item.summary }}</div>
                    <div class="data-num">
                      <span
                        >{{ item.viewCount ? item.viewCount : 0 }}人浏览</span
                      ><span
                        >{{ item.downCount ? item.downCount : 0 }}次下载</span
                      >
                    </div>
                  </div>
                </div>
                <div class="data-tiem">{{ item.lastUpdateTime }}更新</div>
              </router-link>
            </div>
          </el-tab-pane>

          <el-tab-pane label="接口" name="second">
            <div class="data-list">
              <router-link
                v-for="(item, index) in list2"
                :key="index"
                class="data-item"
                :to="'/interface/detail/' + item.id"
              >
                <div class="item-box">
                  <div class="data-info">
                    <div class="title">{{ item.name }}</div>
                    <div class="desc">{{ item.summary }}</div>
                    <div class="data-num">
                      <span
                        >{{ item.viewCount ? item.viewCount : 0 }}人浏览</span
                      ><span
                        >{{ item.downCount ? item.downCount : 0 }}次下载</span
                      >
                    </div>
                  </div>
                </div>
                <div class="data-tiem">{{ item.lastUpdateTime }}更新</div>
              </router-link>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="tab-right">
          <div class="cell" @click="changeOrder('dataCount')">
            数据量
            <span
              class="caret-wrapper "
              :class="{ descending: queryForm.orderName == 'dataCount' }"
            >
              <!-- <i class="sort-caret ascending"></i> -->
              <i class="sort-caret descending"></i>
            </span>
          </div>
          <!--  <div class="cell">
            最多下载
            <span class="caret-wrapper">
             <i class="sort-caret ascending"></i>
              <i class="sort-caret descending"></i>
            </span>
          </div> -->
          <div class="cell" @click="changeOrder('averageScore')">
            评分最高
            <span
              class="caret-wrapper"
              :class="{ descending: queryForm.orderName == 'averageScore' }"
            >
              <!-- <i class="sort-caret ascending"></i> -->
              <i class="sort-caret descending"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDataSetList, getInterfaceList } from "@/api/index";
import image1 from "@/assets/pic_kfzsj.png";
import image2 from "@/assets/pic_jkkf.png";
import image3 from "@/assets/pic_kfzsj.png";
import image4 from "@/assets/pic_yysh.png";

export default {
  data() {
    return {
      list: [],
      list2: [],
      queryForm: {
        orderName: "",
        pageSize: 8
      },
      activeName: "first",
      serviceList: [
        { title: "开放数据", icon: image1, path: "/data_public/index" },
        { title: "接口开放", icon: image2, path: "/interface/index" },
        { title: "开发手册", icon: image3, path: "/develop/detail" },
        { title: "应用审核", icon: image4, path: "/develop/detail?path=3-2" }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    changeOrder(index) {
      if (index == this.queryForm.orderName) {
        this.queryForm.orderName = "";
      } else {
        this.queryForm.orderName = index;
      }
      this.init();
    },
    async init() {
      var data = await getDataSetList(this.queryForm);
      this.list = data.result.data;
      var data1 = await getInterfaceList(this.queryForm);
      this.list2 = data1.result.data;
    },

    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>
<style lang="scss" scoped>
.develop-container .el-tabs__nav-scroll {
  position: relative;
}

.develop-container .el-tabs__nav-scroll .el-tabs__item {
  width: 60px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.develop-container .el-tabs__nav-wrap::after {
  height: 0 !important;
}
.develop-container {
  width: 1200px;
  .data-directory {
    .title {
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
      margin-bottom: 25px;
      margin-top: 20px;
    }
  }
  .tab-right {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    height: 40px;
    align-items: center;
    padding-top: 15px;
    padding-right: 25px;
    .cell {
      margin-left: 30px;
    }
  }
  .data-content {
    position: relative;
    width: 1200px;
    padding: 15px 25px;
    background: #fff;
    height: 600px;
    .data-list {
      width: 100%;
      height: 560px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .data-item {
        // &:hover{

        // }
        width: 275px;

        display: flex;
        flex-direction: column;
        .item-box {
          background: #f8f8f8;
          padding: 15px 15px 10px 15px;
        }
        .data-tiem {
          height: 37px;
          background: #2a7ee3;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          line-height: 20px;
        }
        .data-info {
          width: 100%;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
          .title {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            width: 80%;

            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin: 0 auto;
          }
          .desc {
            font-weight: 400;
            margin-top: 10px;
            height: 100px;
            line-height: 17px;
            font-size: 12px;
            overflow: hidden;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
          }
          .data-num {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 30px;
            > span {
              width: 80px;
              margin-right: 30px;
            }
          }
        }
      }
    }
    margin-bottom: 105px;
  }
  .caret-wrapper {
    display: inline-flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 14px;
    width: 24px;
    vertical-align: middle;
    cursor: pointer;
    overflow: initial;
    position: relative;
  }
  .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;
  }
  .descending .sort-caret.descending {
    border-top-color: #409eff;
  }
  .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
    top: -5px;
  }
  .sort-caret.descending {
    border-top-color: #c0c4cc;
    bottom: -3px;
  }
  /deep/ .el-card__body {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    a {
      color: #333333;
    }
    img {
      margin-right: 20px;
    }
  }
}
</style>
